import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { SpeculationRulesSiteConfig } from '../types'

const speculationRulesSiteConfig: SiteConfigFn<SpeculationRulesSiteConfig> = ({ api, funcLib }) => {
	const requestUrl = api.originalRequest.getUrl()
	const parsedUrl = funcLib.parseUrl(requestUrl)
	const currentPagePath = parsedUrl.pathname

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			currentPagePath,
		},
	}
}

const name = 'speculationRules'

export const config = { site: speculationRulesSiteConfig, name }
